module.exports = __webpack_public_path__ + "img/en.c1d7566d.svg";